import $ from "jquery"
// import request_storage from './request_storage';
import request_storage from "./request_storage.js"

Date.prototype.Format = function(fmt)
{ //author: meizz
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

Date.prototype.Parse = function(str) {
  let group = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
  this.setFullYear(group[1]);
  this.setMonth(parseInt(group[2])-1, group[3]);
  // this.setDate();
  this.setHours(0);
  this.setMinutes(0);
  this.setSeconds(0);
  this.setMilliseconds(0);
}

function login_request(path, params, contentType) {
    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.request_host + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                console.log(e)
                if (e.status == 401) {
                    window.location.href = "/login"
                }
                resolve({err: 1})
                // reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        // if (request_storage.token != null && request_storage.token != "" && path != "/login/auth") {
        //     vo.headers.token = request_storage.token;
        // }
        if (request_storage.token != null && request_storage.token != "") {
            vo.headers.token = `${request_storage.token}`;
        }
        $.ajax(vo) 
        
    })
}

function _request(path, params, contentType) {
    if (window.request_host == null || window.request_host == "") {
        window.location.href = "/login"
    }

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: window.request_host + path,
            type: "POST",
            timeout: 600000,
            headers: {  },
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                console.log(e)
                if (e.status == 401) {
                    window.location.href = "/login"
                }
                resolve({err: -100})
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        // if (request_storage.token != null && request_storage.token != "" && path != "/login/auth") {
        //     vo.headers.token = request_storage.token;
        // }
        if (request_storage.token != null && request_storage.token != "") {
            vo.headers.token = `${request_storage.token}`;
        }
        $.ajax(vo) 
        
    })
}

async function request(path, params, contentType) {
    let rs = await _request(path, params, contentType)
    if (rs.err == -100) {
        return _request(path, params, contentType)
    } else {
        return rs;
    }
}

export {
    request, login_request
}